import { Outlet } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { ShopLayout } from "~/components/ShopLayout";
import { OfflineModal } from "~/components/offline-modal/offline-modal";
import { useUserProductsPos } from "~/api/products/hooks/use-user-products";
import {
  ScreenError,
  ScreenErrorText,
  ScreenErrorTitle
} from "~/components/screen/screen-error";
import { DisplayErrorMessage } from "~/components/display-error-message";
import { DisplayErrorDescription } from "~/components/display-error-message/display-error-description";
import { productsKeys } from "~/api/products/keys";
import { employeeActions } from "~/providers/store/employee";

import { Footer } from "./footer/footer";
import { DialogInactive } from "./dialog-inactive";
import { ProductsGrid } from "./products/products-grid";
import { HeaderCategories } from "./header/header-categories";
import { Panel } from "./panel/panel";
import { PosScannerListener } from "./pos-scanner-listener";

export const PosSellPage = () => {
  const { status, error, refetch } = useUserProductsPos();
  const queryClient = useQueryClient();

  if (status === "error") {
    return (
      <ScreenError
        onClose={() => {
          queryClient.removeQueries({
            queryKey: productsKeys.lists()
          });
          employeeActions.reset();
          refetch();
        }}
        withAnimation={false}
      >
        <ScreenErrorTitle>
          <DisplayErrorMessage error={error} />
        </ScreenErrorTitle>

        <ScreenErrorText>
          <DisplayErrorDescription error={error} />
        </ScreenErrorText>
      </ScreenError>
    );
  }

  return (
    <>
      <ShopLayout
        panel={<Panel />}
        footer={<Footer />}
        header={<HeaderCategories />}
      >
        <ProductsGrid />
      </ShopLayout>

      <Outlet />

      <PosScannerListener />

      <DialogInactive />

      <OfflineModal />
    </>
  );
};
